import styled, { css } from "styled-components";

export const Wrapper = styled.div(({ theme }) => css`
  margin-bottom: 24px;
  box-sizing: border-box;
  .heading {
    font-size: 24px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.33;
    letter-spacing: -0.2px;
    color: ${theme.palette.text.heading};
    margin-bottom: 16px;
  }

  .subheading {
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.38;
    letter-spacing: normal;
    color: ${theme.palette.text.heading};
  }
`);
